import * as React from "react";
import { RefObject } from "react";
import { useClickOutside } from "~/sharedHOC/ClickOutside/useClickOutside";

export const CloseReason = {
    ESC: "ESC",
    CLICK_OUTSIDE: "CLICK_OUTSIDE",
    CLICK_INSIDE: "CLICK_INSIDE",
    TAB: "TAB",
    ENTER: "ENTER",
    SCROLL_PARENT: "SCROLL_PARENT",
};

export type CloseReason = typeof CloseReason[keyof typeof CloseReason];
export type CloseCallback = (reason: CloseReason, e?: Event | React.SyntheticEvent<any>) => void;

export type ClickOutsideProps = {
    closeActionHandler: CloseCallback;
    containerElRef: RefObject<HTMLElement>;
    triggerElRef?: RefObject<HTMLElement>;
};

export const ClickOutside: React.FC<ClickOutsideProps> = ({
    children,
    closeActionHandler,
    containerElRef,
    triggerElRef,
}) => {
    useClickOutside({
        containers: [containerElRef, triggerElRef],
        closeActionHandler,
    });
    return <>{children}</>;
};
